import React from 'react'
import { useDrop } from 'react-dnd'
import { ItemTypes } from './ItemTypes'
import {FieldSelected} from './FieldSelected'

const style = {
  height: 320,
  maxHeight: 320,
  width: 210,
  marginRight: '1rem',
  marginBottom: '1rem',  
  padding: '1rem',
  textAlign: 'center',
  fontSize: '1rem',
  lineHeight: 'normal',
  border: '1px dashed #ccc',  
  overflow: 'auto',
}
function selectBackgroundColor(isActive, canDrop) {
  if (isActive) {
    return 'darkgreen'
  } else if (canDrop) {
    return 'darkkhaki'
  } else {
    return '#fff'
  }
}
export const Dustbin = ({ allowedDropEffect, title, identify, data, eventOnDelete, eventOnColor }) => {
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: ItemTypes.BOX,
    drop: () => ({
      name: `${identify}`,
      allowedDropEffect,
    }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })
  const isActive = canDrop && isOver
  const backgroundColor = selectBackgroundColor(isActive, canDrop)
  return (
    <div ref={drop} style={{ ...style, backgroundColor }}>    
      <h4>{title}</h4>      
      {data?data.map((item, index) => 
        <FieldSelected 
          eventOnColorPicker={eventOnColor}
          identify={identify}
          item={item}
          eventoOnDelete={eventOnDelete}
          key={index} 
          name={item.name} /> ):''}                       
    </div>
  )
}
